import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './_billingProfile.css'
import LineItem from './LineItem'
import Svg from 'components/util/Svg'
import classnames from 'classnames'

export default class BillingProfile extends Component {

  static propTypes = {
    index: PropTypes.number,
    onSelect: PropTypes.func,
    onDelete: PropTypes.func,
    profile: PropTypes.shape({
      default: PropTypes.bool,
      billing_profile_id: PropTypes.string,
      cc_brand: PropTypes.string,
      last4: PropTypes.number,
      billing_zip_code: PropTypes.string,
      cc_expiration_month: PropTypes.number,
      cc_expiration_year: PropTypes.number,
    }),
    allowSelect: PropTypes.bool,
    allowDelete: PropTypes.bool,
    className: PropTypes.string,
    lineItem: PropTypes.bool,
    checked: PropTypes.bool,
    allowEdit: PropTypes.bool,
    onEdit: PropTypes.func,
    style: PropTypes.object,
    id: PropTypes.string,
  }

  static defaultProps = {
    lineItem: true,
    allowSelect: true,
    allowDelete: true,
    allowEdit: false,
  }

  handleDelete = (evt) => {
    const { onDelete, profile } = this.props
    evt.stopPropagation()
    evt.preventDefault()
    if (onDelete) { onDelete(profile) }
  }

  handleSelect = () => {
    const { onSelect, profile } = this.props
    if (onSelect) { onSelect(profile) }
  }

  handleEdit = (evt) => {
    const { onEdit, profile } = this.props
    evt.preventDefault()
    evt.stopPropagation()
    if (onEdit) { onEdit(profile) }
  }

  render () {
    const { style, id, checked, profile, index, allowSelect, allowDelete, allowEdit, lineItem } = this.props
    const _checked = typeof checked === 'boolean' ? checked : profile.default
    const className = classnames(this.props.className, styles.label, {
      [styles.allowSelect]: allowSelect,
      [styles.allowDelete]: allowDelete,
      [styles.allowEdit]: allowEdit,
    })

    return (
      <label id={id} style={style} className={className} htmlFor={`card-${index}`}>

        {React.createElement(lineItem ? LineItem : 'div', {}, [(
          <div key='a' className={styles.container}>
            {allowSelect ?
              <div>
                <input
                  id={`card-${index}`}
                  type='radio'
                  name='cc'
                  checked={_checked}
                  onChange={this.handleSelect}
                  className={styles.input}
                />
              </div>
            : null}

            <Svg
              name={profile.cc_brand.toLowerCase().replace(' ', '-')}
              className={styles.cardIcon}
            />

            <div className={styles.cardInfo}>
              <p>
                <FormattedMessage
                  id='premium.subscriptions.cc_ending_in'
                  defaultMessage='{ccBrand} ending in {last4}'
                  values={{
                    ccBrand: profile.cc_brand,
                    last4: profile.cc_last4,
                  }}
                />
                <span>{'·'}</span>
                {allowEdit ?
                  <span className={styles.link} onClick={this.handleEdit}>
                    <Svg name='edit' fill='currentColor' className={styles.editIcon} />
                    <FormattedMessage
                      id='premium.subscriptions.edit_billing_profile'
                      defaultMessage='Edit'
                    />
                  </span>
              : null}
              </p>
              <p className={styles.cardMoreInfo}>
                <FormattedMessage
                  id='premium.subscriptions.cc_details'
                  defaultMessage='Exp: {expMonth}/{expYear} · Postal Code: {postalCode}'
                  values={{
                    postalCode: profile.billing_zip_code,
                    expMonth: profile.cc_expiration_month,
                    expYear: profile.cc_expiration_year,
                  }}
                />
              </p>
            </div>
          </div>
        ), (
          <div key='b'>
            {allowDelete ?
              <span className={styles.link} onClick={this.handleDelete}>
                <FormattedMessage
                  id='premium.subscriptions.delete_billling_profile'
                  defaultMessage='Delete'
                />
              </span>
            : null}
          </div>
        )])}
      </label>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/premium/BillingProfile.jsx